import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', ''));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/login');
      return;
    }

    (async () => {
      try {
        await exchangeSession(sessionId);
        navigate('/dashboard', { replace: true });
      } catch {
        navigate('/login');
      }
    })();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-diavel-red border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-mono text-xs tracking-wider uppercase text-zinc-500">Autenticando...</p>
      </div>
    </div>
  );
}
